import React from 'react'

import EntityPage from '../components/EntityPage'
import Linkify from '../components/Linkify'
import StatusBadge from '../components/StatusBadge'
import { fmtDate, fmtTime, fmtMoney } from '../components/format'
import { usePersonLabels, joinLabels } from '../api/people'

const Activities: React.FC = () => {
  const labels = usePersonLabels()

  return (
    <EntityPage
      entity="activities"
      title="🗓️ Booked Activities"
      description="Anything booked or planned. Booked items automatically appear on the group calendar."
      addLabel="Add activity"
      emptyHint="Nothing planned yet — check the Ideas tab for inspiration."
      columns={[
        { key: 'date', label: 'Date', render: (r) => fmtDate(r.date) },
        { key: 'time_local', label: 'Time', render: (r) => (r.time_local ? fmtTime(r.time_local) : '') },
        { key: 'activity', label: 'Activity' },
        { key: 'location', label: 'Where' },
        { key: 'who_ids', label: "Who's in", render: (r) => joinLabels(labels, r.who_ids) },
        { key: 'cost_per_person', label: 'Cost/person', render: (r) => fmtMoney(r.cost_per_person) },
        { key: 'status', label: 'Status', render: (r) => <StatusBadge status={r.status} /> },
        {
          key: 'booking_link', label: 'Booking',
          render: (r) =>
            r.booking_link ? (
              <a href={r.booking_link} target="_blank" rel="noopener noreferrer">link</a>
            ) : (''),
        },
        { key: 'notes', label: 'Notes', render: (r) => <Linkify text={r.notes} /> },
      ]}
      fields={[
        { name: 'date', label: 'Date', type: 'date', required: true },
        { name: 'time_local', label: 'Time (Costa Rica local)', type: 'time' },
        { name: 'activity', label: 'Activity', type: 'text', required: true, placeholder: 'Zipline + Tarzan swing' },
        { name: 'location', label: 'Where', type: 'text', placeholder: 'Arenal' },
        { name: 'who_ids', label: "Who's in", type: 'people' },
        { name: 'cost_per_person', label: 'Cost per person ($)', type: 'number' },
        {
          name: 'status', label: 'Status', type: 'select',
          options: [
            { value: 'planning', label: 'Planning' },
            { value: 'booked', label: 'Booked' },
            { value: 'needs_attention', label: 'Needs attention' },
          ],
        },
        { name: 'booking_link', label: 'Booking link', type: 'text', placeholder: 'https://…' },
        { name: 'notes', label: 'Notes', type: 'textarea' },
      ]}
      blank={{ status: 'planning' }}
    />
  )
}

export default Activities
